interface ErrorDisplayProps {
  message?: string;
}

export function ErrorDisplay({ message }: ErrorDisplayProps) {
  return (
    <div className="flex items-center justify-center h-full bg-gray-50 dark:bg-gray-950">
      <div className="text-center p-6 max-w-md mx-auto">
        <div className="text-red-500 dark:text-red-400 mb-3">
          <svg
            className="w-10 h-10 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">
          Something went wrong
        </h2>
        <p className="text-xs text-gray-500 dark:text-gray-400">{message}</p>
      </div>
    </div>
  );
}
